import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SERVICES_DATA } from "config/data";
import { Reveal, StaggerGroup, fadeUp } from "components/ui/motion";

const OurServices = () => {
  return (
    <section className="bg-ink-gradient py-20 text-white">
      <div className="container-tt">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="eyebrow justify-center w-full">
            <span className="h-1.5 w-1.5 rounded-full bg-accent" />
            What we do
          </span>
          <h2 className="mt-4 text-3xl font-semibold sm:text-4xl">Services built for an AI-first world</h2>
          <p className="mt-4 text-base text-white/60">
            End-to-end product engineering — design, build, and ship intelligent mobile and web applications.
          </p>
        </Reveal>

        <StaggerGroup className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES_DATA.map((item, index) => (
            <motion.div
              key={index}
              variants={fadeUp}
              whileHover={{ y: -6 }}
              className="group flex flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-7 backdrop-blur transition-colors duration-300 hover:border-brand-400/50 hover:bg-white/[0.07]"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-gradient shadow-glow">
                <img src={item.image} className="h-6 w-6 brightness-0 invert" alt="" />
              </div>
              <h3 className="mt-5 text-lg font-semibold">{item.title}</h3>
              <p className="mt-2 flex-grow text-sm leading-relaxed text-white/60">{item.shortDesc}</p>
              <Link
                to={item.url}
                className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-accent transition-transform group-hover:translate-x-1"
              >
                Learn more →
              </Link>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default OurServices;
